export default function (context) {
    context.dispatch('settings/open', 'osv', {root: true});
}